// MUI
import Box from '@mui/material/Box';
import { Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { useCallback, useEffect } from 'react';
import HeaderEffect from './HeaderEffect';
import useSettings from '../../hooks/useSettings'
import useSocket from '../../hooks/useSocket';
import { useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import useUserData from '../../hooks/useUserData';
export default function RootLayout({
  children
}) {

  const { userData } = useUserData()

  const { on, off } = useSocket();

  const queryClient = useQueryClient()

  const handlePresale = useCallback((userId) => {
      if(userData?.user?.id ===userId){
        queryClient.invalidateQueries(['UserData'])
        toast.success('Your presale transaction has been processed and recorded.', {
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
      } else {
        queryClient.invalidateQueries(['UserData'])
      }
      
  }, [queryClient, userData?.user?.id])

  useEffect(() => {
    console.log("Component mounted, registering event...");
    on("Presale", handlePresale);
    
    return () => {
        console.log("Component unmounted, removing event...");
        off("Presale", handlePresale);
    };
}, [handlePresale, off, on]);



  const [searchParams, setSearchParams] = useSearchParams();
  const { settings, saveSettings } = useSettings()
  useEffect(() => {
    const refCode = searchParams.get('ref')
    if (refCode) {
      saveSettings({ ...settings, refCode: refCode })
    }
  }, [searchParams])
  useEffect(() => {
    const ref = window.location.search?.split('ref=')?.[1]
    if (ref && ref.length > 0) {
      window.localStorage.setItem('referral', ref)
    }
  }, [window.location])
  return <Box sx={{ background: 'url("/images/bg.png") 50% 100%', backgroundSize: 'contain' }}>
    <HeaderEffect />
    <Box>{children || <Outlet />}</Box>
  </Box>;
}